import { RefObject, useCallback, useEffect, useState } from 'react';

type PropsType<T> = {
  ref: RefObject<T>;
};

type Dimensions = {
  width: number;
  height: number;
};

export const useRefDimensions = <T extends HTMLElement | null>(
  props: PropsType<T>,
) => {
  const { ref } = props;
  const { current } = ref;

  const getDimensions = useCallback(
    (current: RefObject<T>['current']): Dimensions => {
      if (!!current) {
        const boundingRect = current.getBoundingClientRect();
        const { width, height } = boundingRect;
        return { width: Math.round(width), height: Math.round(height) };
      }
      return { width: 0, height: 0 };
    },
    [],
  );
  const newDimensions = getDimensions(current);
  const [dimensions, setDimensions] = useState<Dimensions>(
    getDimensions(current),
  );

  useEffect(() => {
    const hasChanged =
      JSON.stringify(dimensions) !== JSON.stringify(newDimensions);

    if (hasChanged) {
      setDimensions(newDimensions);
    }
  }, [newDimensions, dimensions]);

  return dimensions;
};
